export default theme => ({
  blockContainer: {
    position: 'relative',
    height: '100%',
    width: '100vw',
    minWidth: '1400px',
    backgroundColor: theme.palette.blue.main,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    [theme.breakpoints.down('md')]: {
      backgroundImage: 'none !important',
      display: 'block',
      position: 'relative',
      height: 'initial',
      width: '100%',
      minWidth: 'initial',
      padding: 0,
    },
  },
  bluelight: {
    backgroundColor: theme.palette.blue.light,
  },
  blueultralight: {
    backgroundColor: theme.palette.blue.ultralight,
  },
  background: {
    position: 'absolute',
    zIndex: 1,
    height: '100%',
    width: '100vw',
    minWidth: '1400px',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  bgImg: {
    position: 'absolute',
    height: '100%',
    width: '31.94%',
    background: `no-repeat url(${theme.url('/blocks/b2-bg-home-2.png')})`,
    backgroundSize: 'cover',
    backgroundPosition: 'left',
  },
  yellow: {
    color: theme.palette.yellow.light,
  },
  content: {
    position: 'relative',
    zIndex: 5,
    margin: theme.spacing(12),
    [theme.breakpoints.down('md')]: {
      margin: 0,
      padding: 0,
    },
  },
  main: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& > *': {
      flex: '1 1 0',
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column-reverse',
      alignItems: 'initial',
      display: 'block',
      fontSize: 0,
    },
  },
  wrapperPlayer: {
    position: 'relative',
    minHeight: 450,
    maxHeight: '60vh',
    maxWidth: '100%',
    paddingBottom: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      minHeight: 'initial',
      maxHeight: 600,
      paddingBottom: 0,
    },
    '& img': {
      cursor: 'pointer',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      maxWidth: '100%',
      height: '40vh',
      maxHeight: 450,
      [theme.breakpoints.down('md')]: {
        position: 'relative',
        top: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        height: 'auto',
      },
    },
  },
  playIcon: {
    pointerEvents: 'none',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 100,
    height: 100,
    '& .icon-fill': {
      fill: theme.palette.common.white,
    },
    '& .icon-stroke': {
      stroke: theme.palette.common.white,
    },
    [theme.breakpoints.down('md')]: {
      width: 50,
      height: 50,
    },
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    paddingLeft: theme.spacing(8),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(4, 2, 2, 2),
      '& > *': {
        paddingBottom: theme.spacing(2),
      },
    },
  },
  title: {
    textTransform: 'initial',
    color: theme.palette.common.white,
  },
  desc: {
    '& .danger': {
      color: theme.palette.red.dark,
    },
    padding: `${theme.spacing(4)}px ${theme.spacing(12)}px ${theme.spacing(4)}px 0`,
    [theme.breakpoints.down('md')]: {
      padding: 'initial',
    },
  },
});
